export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14410.84c10920.jpg";